import React, { useState, useEffect } from 'react';
import { fetchPublishedBlogs } from '../services/blogApi';
import { resolveMediaUrl } from '../utils/mediaUrl';

function BlogPageNew({ onArticleClick, isActive }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isActive) {
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });

    const loadBlogs = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await fetchPublishedBlogs();
        setBlogs(data);
      } catch (err) {
        setError(err.message || 'Unable to load articles');
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, [isActive]);
  return (
    <div id="blog-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">Publications & Insights</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            Latest <span className="accent-text">Articles</span>
          </h3>
        </div>

        {loading && <p className="text-neutral-400 text-sm">Loading articles...</p>}
        {error && <p className="text-red-400 text-sm">{error}</p>}

        {!loading && !error && blogs.length === 0 && (
          <p className="text-neutral-400 text-sm">No published articles yet.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="blog-card flex flex-col justify-between p-6 cursor-pointer group"
              onClick={() => onArticleClick(blog.id)}
            >
              <div>
                <div className="aspect-[16/10] overflow-hidden mb-6 relative">
                  <img
                    src={resolveMediaUrl(blog.image)}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                    alt={blog.title}
                  />
                  <span className="absolute top-4 left-4 bg-black/80 px-3 py-1 text-[8px] bank-gothic tracking-widest accent-text">
                    {blog.date}
                  </span>
                </div>
                <h4 className="bank-gothic text-lg mt-3 mb-4 leading-snug group-hover:text-[#c49b66] transition-colors">
                  {blog.title}
                </h4>
                <p className="text-xs text-neutral-400 font-light leading-relaxed mb-6">
                  {blog.excerpt}
                </p>
              </div>
              <div className="flex items-center space-x-2 text-xs bank-gothic text-[#c49b66]">
                <span>Read Article</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogPageNew;
